export const handleChangeDataBottomSheet = (name, value) => ({
    type: 'CHANGE_DATA_BOTTOM_SHEET', name, value
});